'use client'

import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useAddressStoreActions, useBillingAddress, useDeliveryAddress } from '@/stores/useAddressStore'
import { ICustomer } from '@/types/icustomer'
import { Input } from '@/app/[locale]/(ui)/input'
import { AddressInput } from '@/app/[locale]/(ui)/address-input'
import { useTranslations } from 'next-intl'

export const CustomerInfo = () => {
  const t = useTranslations()
  const [cookies, setCookie] = useCookies(['user'])
  const [customerData, setCustomerData] = useState(new ICustomer())
  const [isValidDeliveryAddress, setIsValidDeliveryAddress] = useState(false)
  const [isValidBillingAddress, setIsValidBillingAddress] = useState(false)
  const deliveryAddress = useDeliveryAddress()
  const billingAddress = useBillingAddress()
  const { setDeliveryAddress, setBillingAddress } = useAddressStoreActions()

  const { user } = cookies
  const { email, firstName, lastName, phone } = customerData

  const handleClearDeliveryAddress = () => {
    setDeliveryAddress(undefined)
  }

  const handleClearBillingAddress = () => {
    setBillingAddress(undefined)
  }

  useEffect(() => {
    if (user) {
      setCustomerData({ ...user })
    }
  }, [])

  useEffect(() => {
    //Do not try to set the formData until the user-cookie is populated
    if (!deliveryAddress) return

    if (user && !customerData.hasBeenSetFromVipps) {
      setCustomerData({
        ...user,
        deliveryAddress,
        hasBeenSetFromVipps: true,
      })
    }
  }, [user, deliveryAddress])

  return (
    <div className="max-w-[600px] flex-1">
      <div>
        <div className="grid grid-cols-12 gap-4">
          <h2 className="col-span-12 text-2xl font-bold">{t('Customer_info')}</h2>
          <div className="col-span-12">
            <Input
              required
              label={t('First_name')}
              value={firstName}
              type="text"
              onChange={(e) => {
                setCustomerData({ ...customerData, firstName: e.target.value })
                setCookie('user', { ...customerData, firstName: e.target.value })
              }}
            />
          </div>
          <div className="col-span-12">
            <Input
              required
              label={t('Last_name')}
              value={lastName}
              onChange={(e) => {
                setCustomerData({ ...customerData, lastName: e.target.value })
                setCookie('user', { ...customerData, lastName: e.target.value })
              }}
            />
          </div>
          <div className="col-span-12">
            <Input
              required
              label={t('Phone_number')}
              value={phone}
              type="tel"
              maxLength={8}
              onChange={(e) => {
                if (e.target.value.length < 9) setCustomerData({ ...customerData, phone: e.target.value })
                setCookie('user', { ...customerData, phone: e.target.value })
              }}
            />
          </div>
          <div className="col-span-12">
            <Input
              required
              type="email"
              label={t('Email')}
              value={email}
              onChange={(e) => {
                setCustomerData({ ...customerData, email: e.target.value })
                setCookie('user', { ...customerData, email: e.target.value })
              }}
            />
          </div>
          <div className="col-span-12">
            <AddressInput
              label={t('Billing_address')}
              required
              preSelectedAddress={billingAddress}
              whenAddressIsSelected={(selectedAddress) => setBillingAddress(selectedAddress)}
              isValidAddress={isValidBillingAddress}
              setIsValidAddress={setIsValidBillingAddress}
              handleClearAddress={handleClearBillingAddress}
              allowOutsideDeliveryArea={true}
            />
          </div>
          <div className="col-span-12">
            <AddressInput
              label={t('Service_Address')}
              required
              preSelectedAddress={deliveryAddress}
              whenAddressIsSelected={(selectedAddress) => setDeliveryAddress(selectedAddress)}
              isValidAddress={isValidDeliveryAddress}
              setIsValidAddress={setIsValidDeliveryAddress}
              handleClearAddress={handleClearDeliveryAddress}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
